import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '../../NatureOfBusinessFormProvider/types';
import {
  checkIncomeCategoryNameCompleted,
  filterAndSortBySubgroup,
} from '../utils';
import OtherIncomeEditButton from './OtherIncomeActions/OtherIncomeEditButton';
import OtherIncomeDeleteButton from './OtherIncomeActions/OtherIncomeDeleteButton';
import OtherIncomeYearFieldsForm from './OtherIncomeYearFieldsForm';

type OtherIncomeExtendedFormProps = {
  subgroup: INCOME_SUBGROUP_CATEGORY;
};

const OtherIncomeExtendedForm = ({
  subgroup,
}: OtherIncomeExtendedFormProps) => {
  const { watch } = useNatureOfBusinessForm();
  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const otherIncomeItems = incomeStructure?.otherIncomeItems || {};
  const otherIncomeExtended = filterAndSortBySubgroup(
    otherIncomeItems,
    subgroup
  );

  const defaultTitle =
    subgroup === INCOME_SUBGROUP_CATEGORY.OTHER_OPERATION_INCOME
      ? 'กรุณาระบุรายได้อื่นจากการดำเนินงาน'
      : 'กรุณาระบุรายได้อื่นนอกเหนือจากการดำเนินงาน';

  return (
    <>
      {otherIncomeExtended.map(([key, item]) => (
        <Flex key={key} width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350} justifyItems={'end'}>
            <InputLabel
              sx={{
                textAlign: 'right',
                color: checkIncomeCategoryNameCompleted(item.incomeCategory)
                  ? 'inherit'
                  : 'error.main',
              }}
            >
              {item.incomeCategory?.nameTh && item.incomeCategory?.nameTh !== ''
                ? item.incomeCategory?.nameTh
                : defaultTitle}
            </InputLabel>
            <Flex alignItems={'center'}>
              <Typography textAlign={'right'} color={'text.secondary'}>
                (พันบาท)
              </Typography>
              <OtherIncomeEditButton keyItem={key} subgroup={subgroup} />
              <OtherIncomeDeleteButton keyItem={key} />
            </Flex>
          </Box>
          <OtherIncomeYearFieldsForm keyItem={key} />
        </Flex>
      ))}
    </>
  );
};

export default OtherIncomeExtendedForm;
